import produce from 'immer'
import { SET_BOOKINGS } from './actionTypes'

export const initialState = {
  bookings: {
    data: [],
    count: null,
  },
}

const bookingReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_BOOKINGS:
        draft.bookings = action.data
        break
    }
  })

export default bookingReducer
